/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_GeneratingInputs */

const en_read_along_ai_generating = /** @type {(inputs: Read_Along_Ai_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating…`)
};

const es_read_along_ai_generating = /** @type {(inputs: Read_Along_Ai_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando…`)
};

/**
* | output |
* | --- |
* | "Generating…" |
*
* @param {Read_Along_Ai_GeneratingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_generating = /** @type {((inputs?: Read_Along_Ai_GeneratingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_GeneratingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_generating(inputs)
	return en_read_along_ai_generating(inputs)
});